import { redirect } from 'redux-first-router'
import { t } from 'ttag'

import { toModel } from 'ducks/router'
import { modelActions } from './actions'
import { useItem, useModel } from './hooks'
import { getOrm, modelSelectors } from './selectors'

const translate = (endpoint, plural) => {
  const names = {
    projects: [t`job`, t`jobs`],
    candidates: [t`candidate`, t`candidates`],
    templates: [t`template`, t`templates`],
    documents: [t`document`, t`documents`],
    departments: [t`department`, t`departments`],
    users: [t`user`, t`users`],
  }
  return names[endpoint]?.[plural ? 1 : 0] ?? '??'
}

const endpointOrm = endpoint => ({
  ...modelActions(endpoint),
  ...modelSelectors(endpoint),
  // TODO: have to consider to adjust model, so that we do not need to pass undefined, undefined
  toList: () => toModel(endpoint, undefined, undefined),
  toCreate: (tab = 1) => toModel(endpoint, 'add', tab),
  toDetail: (pk, tab: number | null = 1, query?, replace = false) => {
    const action = toModel(endpoint, pk, tab, query)
    return replace ? redirect(action) : action
  },
  useModel: (params?) => useModel(endpoint, params),
  useItem: pk => useItem(endpoint, pk),
  pluralize: n => translate(endpoint, n !== 1),
  toString: () => translate(endpoint, true),
  endpoint,
})

// anything that is not an endpoint name is returned as it is
const orm = endpoint =>
  typeof endpoint === 'string' ? endpointOrm(endpoint) : endpoint

export default orm
export { getOrm, useModel, useItem }

export const accounts = endpointOrm('accounts')
export const candidates = endpointOrm('candidates')
export const documents = endpointOrm('documents')
export const interviewTemplates = endpointOrm('interviewtemplates')
export const jobs = endpointOrm('projects')
export const jobTemplates = endpointOrm('projecttemplates')
export const questions = endpointOrm('interview/questions')
export const skills = endpointOrm('projectskills')
export const templates = endpointOrm('templates')
export const overviewCareer = endpointOrm('careeroverview')
export const invitesCareer = endpointOrm('careerinvites')
export const resultsCareer = endpointOrm('resultscareer')
export const departments = endpointOrm('departments')
export const users = endpointOrm('users')
export const interviews = endpointOrm('interviews')
